$(document).ready(function(){
    
    $('.shopify-app-block').addClass('container');
    $('a.c-order-note').on('click', function(e) {
        e.preventDefault(); // Prevent default action of the a tag
        $('.cartdrawer-order-notes-field').addClass('active');
    });
    $('a.close-drawer-note').on('click', function(e) {
        e.preventDefault(); // Prevent default action of the a tag
        $('.cartdrawer-order-notes-field').removeClass('active');
    });
    $('.filters-button').on('click', function(e) {
        e.preventDefault(); // Prevent default action of the a tag
        $('.shop-page-content .col-lg-2').addClass('active');
    });
     $('#buy-it-now2').on('click', function() {
        $('.popup .add-to-cart').addClass('not-loading');
    });
    $('.hide-filters').on('click', function(e) {
        $('.shop-page-content .col-lg-2').removeClass('active');
    });
    $('.nav-item > .link-div > .parent-dropdown-button').on('click' , function(e){
      e.preventDefault();
      t = $(this);
      t.toggleClass('active');
      t.closest('.nav-item').find('.dropdown-menu').slideToggle();
	  });
    $('.dropdown-menu-button').on('click' , function(e){
      e.preventDefault();
      t = $(this);
      t.toggleClass('active');
      t.closest('.link-div').siblings('.dropdown-submenu').slideToggle();
	  });
    $('.search-icon-toggle').on('click', function(e) {
        e.preventDefault();

        $('.navbar-content').toggleClass('active');
        $('.suggestionList').removeClass('active');
        $('.suggestionList').css('display', 'none');

        // Wait for 100ms to ensure input is visible, then focus
        setTimeout(function() {
            $('input.search-input').focus();
        }, 100);
    });
    $('.searchFormFeilds .search-icon-toggle').on('click', function(e) {
    e.preventDefault();

    // Clear the input field inside .searchFormFeilds
    $('.searchFormFeilds input.search-input').val('');
    });
    $('.single-product-info2 .add-to-cart').on('click', function() {
       $('.modal-backdrop').css('opacity', '0').css('transition', 'opacity 0.5s ease-in-out');
       $('.quick-product-view').css('opacity', '0').css('transition', 'opacity 0.5s ease-in-out');
      // Hide elements after 4 seconds
      setTimeout(function() {
          $('.quick-product-view').css('display', 'none');
          $('.quick-product-view').toggleClass('show');
          $('.modal-backdrop').remove();
          $('body').removeClass('modal-open').removeAttr('style');
          $('.single-product-info2').removeClass('both-selected');
          $('.quick-product-view')
            .attr('aria-hidden', 'true') 
            .removeAttr('aria-modal')
            .removeAttr('role');  
      }, 3000); // 4000 milliseconds = 4 seconds

    });
    $('.sidebar-cart-carousel .owl-carousel').owlCarousel({
        loop: true,
        margin: 15,
        nav: true,
        dots: true,
        autoplay: true,
        autoplayTimeout: 5000, // Reduced autoplay speed
        autoplayHoverPause: true, // Stops autoplay on hover
        responsive: {
            0: {
                items: 1
            },
            667: {
                items: 1.5
            }
        }
    });
   var owl = $('.owl-ticker').owlCarousel({
        loop: true,
        margin: 10,
        nav: false,
        dots: false,
        autoplay: true,
        autoplayTimeout: 3000,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 1
            },
            1000: {
                items: 1
            }
        }
    });
    $('.owl-reviews').each(function () {
        var slidesToShow = $(this).data('slides') || 2; // Default to 3 if not set

        $(this).owlCarousel({
            loop: true,
        margin: 0,
        nav: true,
        dots: false, 
        // autoplay: true,
        // autoplayTimeout: 3000, 
        // autoplayHoverPause: true, 
            responsive: {
                0: {
                    items: 1
                },
                600: {
                    items: 1
                },
                1000: {
                    items: slidesToShow // Use the dynamic value for larger screens
                }
            }
        });
    });

    // Refresh the carousel after a short delay to ensure the width is calculated correctly
    setTimeout(function() {
        owl.trigger('refresh.owl.carousel');
    }, 100);
    // Initialize Owl Carousel
    var enableAutoslide = null;
    var slideAnimation = null;
    $('.owl-brands').owlCarousel({
        loop: true,
        margin: 10,
        nav: false,
        dots: false,
        autoplay: enableAutoslide,
        autoplayTimeout: 3000,
        autoplayHoverPause: true,
        smartSpeed: 600,
        responsive: {
        0: { items: 3 },
        600: { items: 4 },
        1000: { items: 7 }
        }
    });

    // Function to apply animation to active slides
    function applyAnimation() {
        if (!slideAnimation) return; // If no animation is selected, exit

        // Remove previous animation classes from all items
        $('.owl-brands .item').removeClass(function(_, className) {
        return (className.match(/(^|\s)animate__\S+/g) || []).join(' ');
        });

        // Add animation classes to active items
        $('.owl-brands .owl-item .item').each(function () {
        var $el = $(this);

        // Trigger a reflow to restart animation
        void this.offsetWidth; // Forces the browser to recalculate the element's layout

        // Add the correct animation class
        if (slideAnimation) {
            $el.addClass('animate__animated').addClass(slideAnimation); // Directly use the selected animation
        }
        });
    }

    // Apply animation when the slide changes
    $('.owl-brands').on('changed.owl.carousel initialized.owl.carousel refreshed.owl.carousel', function() {
        applyAnimation(); // Apply animation to the new active slides
    });

    // Apply animation immediately on initial load (for the first visible slides)
    $(document).ready(function () {
        applyAnimation();
    });
    
});





document.addEventListener('click', function(event) {
  const cartSidebar = document.querySelector('.cart-sidebar');
  const cartSidebarParent = document.querySelector('.cart-sidebar-parent');

  // Check if click is outside the cart sidebar
  if (cartSidebar && cartSidebarParent && !cartSidebar.contains(event.target)) {
    cartSidebarParent.classList.remove('active');
  }
});



document.addEventListener("DOMContentLoaded", function() {
    const ticker = document.querySelector('section.ticker');
    const closedAt = localStorage.getItem('tickerClosedAt');
    const now = new Date().getTime();
    const oneDay = 24 * 60 * 60 * 1000;

    // Remove ticker if previously closed within 24 hours
    if (localStorage.getItem('tickerClosed') === 'true' && closedAt && now - closedAt < oneDay) {
        ticker.remove();
    } else {
        ticker.style.display = 'block'; // Reveal it only if needed
    }

    // Close button logic
    const closeBtn = document.querySelector('.close-ticker');
    if (closeBtn) {
        closeBtn.addEventListener('click', function(e) {
            e.preventDefault();
            ticker.remove();
            localStorage.setItem('tickerClosed', 'true');
            localStorage.setItem('tickerClosedAt', now);
        });
    }
});



document.addEventListener('DOMContentLoaded', function() {
  updateCartCount();

  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        let cartCountElements = document.querySelectorAll('.cart-count');
        let cartCount = cart.item_count;

        cartCountElements.forEach(cartCountElement => {
          if (cartCount > 0) {
            cartCountElement.textContent = cartCount;
            cartCountElement.style.display = 'flex'; // Show when items are in the cart
          } else {
            cartCountElement.style.display = 'none'; // Hide when no items in the cart
          }
        });
      });
  }

  document.addEventListener('cart:updated', updateCartCount);
});
document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
  form.addEventListener('submit', function() {
    setTimeout(() => {
      document.dispatchEvent(new Event('cart:updated'));
    }, 1000); // Adjust timeout as needed
  });
});





/**** search Js  ****/
function validateSearchForm() {
    const searchInput = document.getElementsByClassName('search-input');
    // Prevent form submission if the input is empty or only contains spaces
    return searchInput.value.trim() !== '';
}



// Function to decode HTML entities
function decodeHtmlEntities(str) {
  const textArea = document.createElement('textarea');
  textArea.innerHTML = str;
  return textArea.value;
}


const SHOP_MONEY_FORMAT = null;
async function suggestionList(inputEl) {
    const form = inputEl.closest('form');
    const suggestionList = form.querySelector('.suggestionList');
    const productsTab = form.querySelector('.productsList');
    const collectionsTab = form.querySelector('.collectionsList');
    const serachClear = form.querySelector('.search-icon-toggle');

    if (inputEl.value.length > 0) {
        serachClear.style.visibility = 'visible';
        suggestionList.style.display = 'block';
        suggestionList.classList.add('active');
        const query = inputEl.value.toLowerCase();
        const type = form.querySelector('input[name="type"]').value;

        const response = await fetch(`/search?view=ajax&type=${type}&q=${query}`);
        const { collections, items } = await response.json();

        productsTab.innerHTML = "";
        collectionsTab.innerHTML = "";

        // Render collections
        const filteredCollections = collections.filter(collection =>
            collection.title.toLowerCase().includes(query)
        );

        if (filteredCollections.length > 0) {
            filteredCollections.forEach(collection => {
                let imageSrc = collection.image && collection.image !== 'null'
                    ? collection.image
                    : (collection.first_product_image && collection.first_product_image !== 'null'
                        ? collection.first_product_image
                        : `https://${window.location.host}/cdn/shop/t/47/assets/placeholder-img.webp`);

                if (collection.item_count > 0) {
                    collectionsTab.innerHTML += `
                        <div class="search-item">
                            <a href="${collection.url}">
                                <div class="image-wrapper">
                                    <img src="${imageSrc}" alt="${collection.title}" width="50">
                                </div>
                                <div class="content-wrapper">
                                    <span style="font-weight: bold;">${collection.title}</span>
                                    <span> (${collection.item_count} items)</span>
                                </div>
                            </a>
                        </div>
                    `;
                }
            });
        } else {
            collectionsTab.innerHTML = "<p>No collections found.</p>";
        }

        // Render products with WDP discount logic
        if (items.length > 0) {
           items.forEach(item => {
  const imageSrc = item.image && item.image !== 'null'
    ? `https://${window.location.host}/cdn/shop/${item.image}`
    : `https://${window.location.host}/cdn/shop/t/47/assets/placeholder-img.webp`;

  const skuHTML = item.sku && item.sku.trim() !== ""
    ? `<div class="sku"><small>SKU: ${item.sku}</small></div>`
    : '';

  const variant = item.wcp_json?.variants?.[0] || {};
  const rawPrice = Number(variant.price ?? item.price ?? 0);
  const rawCompare = Number(variant.compare_at_price ?? 0);

  const finalPrice = rawPrice > 0 ? `$${(rawPrice / 100).toFixed(2)}` : '';
  const comparePrice = rawCompare > rawPrice ? `$${(rawCompare / 100).toFixed(2)}` : '';

  console.log("WDP Data for:", item.title, variant);

  productsTab.innerHTML += `
    <div class="search-item">
      <a href="${item.url}">
        <div>
          <div class="image-wrapper">
            <img src="${imageSrc}" alt="${item.title}" width="50">
          </div>
          <div class="content-wrapper">
            <span style="font-weight: bold;">${item.title}</span>
            ${skuHTML}
          </div>
        </div>
        <div class="suggestions-price">
          <div class="price">
            <span
              class="price-item price-item--regular"
              data-wpd-product-handle="${item.handle}"
              data-wpd-variant-id="${variant.id || ''}"
              data-wpd-variant-price="${variant.price || ''}"
              data-wpd-variant-compare-at-price="${variant.compare_at_price || ''}"
              data-wpd-product-id="${item.id}"
            >
              ${comparePrice ? `<span class="compare-at-price">${comparePrice}</span>` : ''}
              ${finalPrice ? `<span class="price">${finalPrice}</span>` : ''}
            </span>
          </div>
        </div>
      </a>
    </div>
  `;
});


            // ✅ Reinitialize WDP discount app if needed
            if (window.WCP && typeof WCP.init === 'function') {
                WCP.init();
            }
        } else {
            productsTab.innerHTML = "<p>No products found.</p>";
        }
    } else {
        suggestionList.style.display = 'none';
        suggestionList.classList.remove('active');
    }
}
setTimeout(() => {
  if (window.wpdApp?.refreshPrices) {
    window.wpdApp.refreshPrices();
  }
}, 300);





document.addEventListener('click', function (event) {
    const searchForm = document.querySelector('.menu-searchbar .search-form');
    const suggestionBox = document.querySelector('.suggestionList');

    if (suggestionBox && !searchForm.contains(event.target)) {
        suggestionBox.style.display = 'none';
        suggestionBox.classList.remove('active');
    }
});


// Add event listeners for focus and blur









var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "$";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};



function checkVariantSelections(context) {
    var fieldsets = $(context).find('.product-option fieldset');
    var selectedClassTargets = $(context).find('.single-product-info, .single-product-info2');

    if (fieldsets.length >= 3) {
        if (
            fieldsets.eq(0).find('input:checked').length &&
            fieldsets.eq(1).find('input:checked').length &&
            fieldsets.eq(2).find('input:checked').length
        ) {
            selectedClassTargets.addClass('both-selected');
        } else {
            selectedClassTargets.removeClass('both-selected');
        }
    } else if (fieldsets.length === 2) {
        if (
            fieldsets.eq(0).find('input:checked').length &&
            fieldsets.eq(1).find('input:checked').length
        ) {
            selectedClassTargets.addClass('both-selected');
        } else {
            selectedClassTargets.removeClass('both-selected');
        }
    } else if (fieldsets.length === 1) {
        if (fieldsets.eq(0).find('input:checked').length) {
            selectedClassTargets.addClass('both-selected');
        } else {
            selectedClassTargets.removeClass('both-selected');
        }
    } else {
        selectedClassTargets.removeClass('both-selected');
    }
}

// Attach event
$(document).on('change', '.product-option input', function () {
    checkVariantSelections($(this).closest('.quick-product-view, .product-detail-info'));
});

// Also call this after loading quick view
// After AJAX loads related product content
checkVariantSelections($('.quick-view-modal'));




/*** colleciton page products variations ***/
document.addEventListener("DOMContentLoaded", function() {
    // Function to initialize swatch functionality for any given set of swatches
    function initializeSwatchFunctionality(swatches) {
        swatches.forEach(function(swatch) {
            swatch.addEventListener("click", function() {
                const productId = swatch.getAttribute("data-product-id");
                const productCard = document.querySelector(`.product-item[data-product-id='${productId}']`);
                const variantImage = swatch.getAttribute("data-variant-image");
                const productImage = productCard.querySelector(".product-image a img");

                if (!productImage) {
                    console.error(`Product image not found for product ID ${productId}`);
                    return;
                }

                // Uncheck and deselect other swatches in the same product card
                const allSwatches = productCard.querySelectorAll(".color-swatches input[type='checkbox']");
                allSwatches.forEach(s => {
                    if (s !== swatch) {
                        s.checked = false;
                        s.classList.remove("selected");
                    }
                });

                // Add 'selected' class and update image
                if (swatch.checked) {
                    swatch.classList.add("selected");
                    if (variantImage && variantImage.trim() !== "" && variantImage !== "undefined") {
                        productImage.src = variantImage;
                    }
                } else {
                    swatch.classList.remove("selected");
                }
            });
        });
    }

    // 1. Handle swatches on the initial page load (for the shop page)
    const initialSwatches = document.querySelectorAll(".color-swatches input[type='checkbox']");
    if (initialSwatches.length > 0) {
        console.log("Initial swatches found:", initialSwatches.length);
        initializeSwatchFunctionality(initialSwatches);
    }

    // 2. Handle swatches in the recommendations section (dynamically loaded)
    const productRecommendationsSection = document.querySelector(".product-recommendations");

    if (productRecommendationsSection) {
        const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.addedNodes.length) {
                    const swatches = productRecommendationsSection.querySelectorAll(".color-swatches input[type='checkbox']");
                    if (swatches.length > 0) {
                        console.log("Dynamically loaded swatches found:", swatches.length);
                        initializeSwatchFunctionality(swatches);
                    }
                }
            });
        });

        // Observe the recommendations section for dynamically added content
        observer.observe(productRecommendationsSection, { childList: true, subtree: true });
    }
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:select', function (event) {
    const sectionId = event.detail?.sectionId;

    if (sectionId === 'cartdrawer') {
      document.querySelector('.cart-sidebar-parent')?.classList.add('active');
      document.querySelector('.cart-sidebar')?.classList.remove('hidden');

      // Bind close-sidebar button again
      const closeBtn = document.querySelector('.close-sidebar');
      closeBtn?.addEventListener('click', function () {
        document.querySelector('.cart-sidebar-parent')?.classList.remove('active');
      document.querySelector('.cart-sidebar')?.classList.add('hidden');
      });
    }
  });
}



document.addEventListener('DOMContentLoaded', function () {
  const qtyInput = document.querySelector('#quantity2');
  const soldOutMessage = document.querySelector('#sold-out-message');

  function updateModalQuantityLimit() {
    const variantIdInput = document.querySelector('#modal-product-variant-id');
    if (!variantIdInput) return;

    const currentVariantId = variantIdInput.value.trim();

    if (!currentVariantId) return;

    // Debugging log
     // console.log('Checking variant ID:', currentVariantId);

    const matchingDiv = document.querySelector(`div[data-variant-id="${currentVariantId}"]`);

    if (!matchingDiv) {
      console.warn('No matching variant found for ID:', currentVariantId);
      return;
    }

    const quantity = parseInt(matchingDiv.getAttribute('data-inventory-quantity'), 10);
    const available = matchingDiv.getAttribute('data-available') === 'true';

    // Debugging
    //  console.log('Found variant → Qty:', quantity, '| Available:', available);

    if (available && quantity > 0) {
      qtyInput.setAttribute('max', quantity);
      qtyInput.setAttribute('data-max', quantity);
      if (parseInt(qtyInput.value, 10) > quantity || parseInt(qtyInput.value, 10) < 1) {
        qtyInput.value = 1;
      }
      if (soldOutMessage) soldOutMessage.style.display = 'none';
    } else {
      qtyInput.setAttribute('max', 0);
      qtyInput.setAttribute('data-max', 0);
      qtyInput.value = 0;
      if (soldOutMessage) {
        soldOutMessage.textContent = 'Sold Out';
        soldOutMessage.style.display = 'block';
      }
    }
  }

  // Run it every second
  setInterval(updateModalQuantityLimit, 1000);
});


function calculateZCartSubtotal() {
    let total = 0;

    // Loop through all span.cart-item-price
    document.querySelectorAll('.zcart-item-price span.cart-item-price').forEach(function (el) {
      let priceText = el.textContent.trim();

      // Remove currency symbols and commas, convert to float
      let numeric = parseFloat(priceText.replace(/[^0-9.-]+/g, ''));

      if (!isNaN(numeric)) {
        total += numeric;
      }
    });

    // Optional: Get currency symbol from any cart price
    let currencySymbol = document.querySelector('.cart-item-price')?.textContent.trim().replace(/[0-9.,\s]/g, '') || '$';

    // Format total and update the subtotal span
    const formattedTotal = currencySymbol + total.toFixed(2);
    const subtotalEl = document.querySelector('.zcart-subtotal');

    if (subtotalEl) {
      subtotalEl.textContent = formattedTotal;
    }
  }

  // Run once on page load
  document.addEventListener('DOMContentLoaded', function () {
    calculateZCartSubtotal();

    // Then repeat every 1 second
    setInterval(calculateZCartSubtotal, 1000);
  });





   function formatCurrency(value) {
    return new Intl.NumberFormat('en-AU', {
      style: 'currency',
      currency: 'AUD'
    }).format(value);
  }

  function getJSONData(productId) {
    const script = document.getElementById('wcp_json_' + productId);
    if (!script) {
      console.warn('❌ Script tag not found for product ID:', productId);
      return null;
    }

    try {
      return JSON.parse(script.textContent || script.innerText);
    } catch (e) {
      console.error('❌ Failed to parse JSON:', e);
      return null;
    }
  }

  function updatePricesFromVariant() {
    const variantInput = document.querySelector('input#product-id');
    if (!variantInput) {
     // console.error('❌ Variant input not found');
      return;
    }

    const currentVariantId = variantInput.value;
    const productIdMatch = variantInput.getAttribute('data-product-id'); // we’ll use this
    if (!productIdMatch) {
      // console.error('❌ Missing data-product-id attribute');
      return;
    }

    const jsonData = getJSONData(productIdMatch);
    if (!jsonData || !jsonData.variants) return;

    const variant = jsonData.variants.find(v => String(v.id) === String(currentVariantId));
    if (!variant) {
      // console.warn('⚠️ No matching variant for ID:', currentVariantId);
      return;
    }

    const salePrice = variant.price / 100;
    const comparePrice = variant.compare_at_price / 100;

    const saleEl = document.getElementById('wpd-sale-price');
    const oldEl = document.getElementById('wpd-old-price');

    if (saleEl) saleEl.textContent = formatCurrency(salePrice);
    if (oldEl) {
      if (comparePrice > salePrice) {
        oldEl.style.display = 'inline';
        oldEl.textContent = formatCurrency(comparePrice);
      } else {
        oldEl.style.display = 'none';
      }
    }
  }

  // Run every second
  setInterval(updatePricesFromVariant, 1000);




  //  inject popup input attr

document.addEventListener("DOMContentLoaded", function () {
  // Quick View button click
  

  // When modal closes
  document.addEventListener("hidden.bs.modal", function (e) {
    if (e.target.id === "staticBackdrop") {
      const modalInput = document.querySelector("#modal-product-variant-id");
      if (modalInput) {
        // Remove name attribute and clear value
        modalInput.removeAttribute("name");
      }
    }
  });
});









